import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { tooltipDriverFactory } from '../Tooltip/Tooltip.uni.driver';
import { dataHooks } from './StatusIndicator.constants';
import {
  BaseUniDriver,
  UniDriver,
} from '@wix/wix-ui-test-utils/dist/types/unidriver';
import { StatusIndicatorState } from './StatusIndicator.types';

export interface StatusIndicatorUniDriver extends BaseUniDriver {
  getStatus(): Promise<StatusIndicatorState>;
  hasMessage(): Promise<boolean>;
  getMessage(): Promise<string | null>;
}

export const statusIndicatorDriverFactory = (
  base: UniDriver,
  body: UniDriver,
): StatusIndicatorUniDriver => {
  const tooltipSelector = `[data-hook="${dataHooks.tooltip}"]`;
  const tooltipDriver = () =>
    tooltipDriverFactory(base.$(tooltipSelector), body);

  return {
    ...baseUniDriverFactory(base),

    /** Returns the type of the status oneOf(error, warning, success, loading) */
    getStatus: async (): Promise<StatusIndicatorState> =>
      (await base.attr('data-status')) as StatusIndicatorState,

    /** Returns true if a message was provided */
    hasMessage: async () => await tooltipDriver().exists(),

    /** Returns the message text */
    getMessage: async () => await tooltipDriver().getTooltipText(),
  };
};
